import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectOfferCategory } from '../../../selectors';
import { selectOfferValuationData } from '../../../store/offerValuation';

export const usePricesBlockData = () => {
  const offerValuationData = useSelector(selectOfferValuationData);
  const offerCategory = useSelector(selectOfferCategory);

  return React.useMemo(() => {
    if (!offerValuationData || !offerValuationData.priceInfo) {
      return null;
    }

    const isLandSale = offerCategory === 'landSale';

    const { offerPrice, estimation, estimationRange, infoUrl, priceTag } = offerValuationData.priceInfo;

    return {
      offerPrice,
      estimationPrice: estimation,
      estimationLabel: 'Оценка Циан',
      estimationRange,
      offerLabel: `Цена в объявлении ${isLandSale && priceTag.priceLabel ? priceTag.priceLabel : ''}`.trimEnd(),
      infoUrl,
      priceTagInfo: priceTag.priceLabel && !isLandSale ? { ...priceTag, priceLabel: priceTag.priceLabel } : null,
    };
  }, [offerCategory, offerValuationData]);
};
